import "./Chromatography.module.css";
import Header from "@/reusable_sections/Header";
import Chromatography from "./sections/Chromatography";
import ChromatographyApplications from "./sections/ChromatographyApplications";
import ApplicationInquiry from "./sections/ApplicationInquiry";
import RelatedSolutions from "./sections/RelatedSolutions";
import SupportServices from "./sections/SupportServices";
import Footer from "@/reusable_sections/Footer";
export default function ChromatographyPage() {
  return <div>
      <Header />
      <Chromatography />
      <ChromatographyApplications />
      <RelatedSolutions />
      <SupportServices />
      <ApplicationInquiry />
      <Footer />
    </div>;
}